import React from "react";
export default function Space(props) {
    return (<div
        style={{ width: props.width, height: props.height }}
    ></div>)
}